import MuiFormLabel from './muiFormLabel'
export default MuiFormLabel
